import { Outlet, useNavigate } from 'react-router-dom';
import { useAutoLogout } from '../../customHook/useAutoLogout';
import { useDispatch } from 'react-redux';
import { CLEAR_FORM_DATA } from '../../redux-state/types';

const AutoLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    localStorage.clear();
    dispatch({
      type: CLEAR_FORM_DATA,
    });
    navigate('/login');
  };

  useAutoLogout(handleLogout);

  return <Outlet />;
};

export default AutoLogout;
